export const parseDate = dateString => {
  const [day, month, yearAndTime] = dateString.split(".");
  const [year, time] = yearAndTime.split(" ");
  return new Date(`${year}-${month}-${day}T${time}`);
};
